export default __webpack_public_path__ + "static/media/inrlogo3.b9dbcdaf.svg";